import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Truck, RotateCcw, Headphones, CreditCard } from "lucide-react";
import Logo from "@/components/common/Logo";
import { useI18n } from "@/i18n/I18nProvider";
import { POLICY_ORDER } from "@/i18n/policies";

const TRUST = [
  ["trust_secure", "trust_secure_d", ShieldCheck],
  ["trust_protection", "trust_protection_d", Truck],
  ["trust_returns", "trust_returns_d", RotateCcw],
  ["trust_support", "trust_support_d", Headphones],
];

export default function Footer() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  return (
    <footer className="mt-12 border-t border-border bg-secondary/40" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 py-10 sm:grid-cols-4">
        {TRUST.map(([title, desc, Icon]) => (
          <div key={title} className="flex items-start gap-3">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-background shadow-soft"><Icon size={20} className="text-brand" /></span>
            <div>
              <div className="text-sm font-bold text-ink">{t(title)}</div>
              <div className="text-xs text-muted-foreground">{t(desc)}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="border-t border-border">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 md:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">{t("hero_subtitle")}</p>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-bold text-ink">{t("all_categories")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/shop" className="hover:text-brand">{t("best_sellers")}</Link></li>
              <li><Link to="/deals" className="hover:text-brand">{t("flash_deals")}</Link></li>
              <li><Link to="/shop?sort=newest" className="hover:text-brand">{t("new_arrivals")}</Link></li>
              <li><Link to="/track" className="hover:text-brand">{t("track_order")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-bold text-ink">{t("my_account")}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/account" className="hover:text-brand">{t("dashboard")}</Link></li>
              <li><Link to="/account/orders" className="hover:text-brand">{t("orders")}</Link></li>
              <li><Link to="/wishlist" className="hover:text-brand">{t("wishlist")}</Link></li>
              <li><Link to="/cart" className="hover:text-brand">{t("cart")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-bold text-ink">{t("newsletter_title")}</h4>
            <p className="mb-3 text-sm text-muted-foreground">{t("newsletter_sub")}</p>
            {done ? (
              <p className="text-sm font-semibold text-success">{t("subscribed")}</p>
            ) : (
              <form onSubmit={(e) => { e.preventDefault(); if (email) setDone(true); }} className="flex gap-2">
                <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder={t("email_placeholder")} className="h-11 flex-1 rounded-full border border-border bg-background px-4 text-sm outline-none focus:border-brand" data-testid="newsletter-input" />
                <button className="h-11 rounded-full bg-brand px-5 text-sm font-semibold text-brand-foreground hover:brightness-105" data-testid="newsletter-submit">{t("subscribe")}</button>
              </form>
            )}
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto max-w-7xl px-4 py-6">
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-muted-foreground" data-testid="footer-legal">
            {POLICY_ORDER.map(([slug, nameKey]) => (
              <Link key={slug} to={`/pages/${slug}`} className="hover:text-brand">{t(nameKey)}</Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-muted-foreground sm:flex-row">
          <span>© {new Date().getFullYear()} KHA. {t("announce_protection")}.</span>
          <span className="flex items-center gap-1.5"><CreditCard size={15} /> Visa · Mastercard · PayPal</span>
        </div>
      </div>
    </footer>
  );
}
